import React from "react";
import HorizontalRegistrationStepper from "./HorizontalRegistrationStepper";
import LeftNavigation from "./LeftNavigation";
import type { LeftNavigationPreviewProps } from "./LeftNavigation";

/**
 * Renders compact horizontal progress (≤899px) and left sidebar (≥900px) via CSS;
 * only one is visible at a time.
 */
function WizardNavLayout(props: LeftNavigationPreviewProps) {
  return (
    <>
      <div className="dxp-horizontal-stepper-wrap">
        <HorizontalRegistrationStepper {...props} />
      </div>
      <LeftNavigation {...props} />
    </>
  );
}

export default WizardNavLayout;
